const ImportTypes = {
  ALL: "ALL",
  LIVE: "LIVE",
  XLXS: "XLSX",
  DRAFT: "DRAFT"
};

export default ImportTypes;